import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logoutRequest } from "../../auth/logout";
import {
  checkAuthenticate,
  resetAuthData,
} from "../../../app/providers/authSlice";
import { myroutes } from "../../../routes/webroute";
import { afficherOneMessageError } from "../../../utils/helpers";

export default function SideBar() {
  const auth = useSelector((state) => state.auth);
  const profils = useSelector((state) => state.auth.profil);
  const profil_habilitation = useSelector(
    (state) => state.auth.profil_habilitation
  );

  //Check profil
  const checkProfil = () => {
    if (
      !profil_habilitation.includes("INTERFACE-ADMIN") &&
      profil_habilitation.includes("ADMIN-RW") &&
      profil_habilitation.includes("ADMIN-RO")
    ) {
      logoutRequest(auth.token);
      dispatch(resetAuthData());
      navigate(myroutes.login);
      afficherOneMessageError(
        "Vous n'êtes pas autorisé à accéder  à cette page"
      );
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const currentPath = location.pathname;

  // check if user is authenticate
  dispatch(checkAuthenticate());
  // Vérifier si le token existe et n'est pas expiré
  if (!auth.isAuthenticate) {
    //deconnecter l'utilisateur et renvoi sur login page
    dispatch(resetAuthData());
    navigate(myroutes.login);
  }

  useEffect(() => {
    //console.log("Profils:", profils);
    checkProfil();
  }, []);

  return (
    <React.Fragment>
      {/* ======= Sidebar ======= */}
      <aside id="sidebar" className="sidebar" style={{ textTransform: "" }}>
        <ul className="sidebar-nav" id="sidebar-nav">
          {!profils.includes("PDT") &&
            !profils.includes("SJ") &&
            !profils.includes("CMPT") && (
              <>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      currentPath == myroutes.dashboard ? "active" : ""
                    }`}
                    to={myroutes.dashboard}
                  >
                    <i className="bi bi-grid"></i>
                    <span>Accueil</span>
                  </Link>
                </li>
                {/* End Dashboard Nav */}

                <li className="nav-item">
                  <Link
                    className="nav-link collapsed"
                    data-bs-target="#dossiers-nav"
                    data-bs-toggle="collapse"
                  >
                    <i className="bi bi-journal-text"></i>
                    <span>Dossiers</span>
                    <i className="bi bi-chevron-down ms-auto"></i>
                  </Link>
                  <ul
                    id="dossiers-nav"
                    className="nav-content collapse "
                    data-bs-parent="#sidebar-nav"
                  >
                    {/**  <li>
                  <Link to={myroutes.creer_dossier}>
                    <i className="bi bi-circle"></i>
                    <span>Créer un dossier</span>
                  </Link>
                </li>
                <li>
                  <Link to={myroutes.creer_dossier}>
                    <i className="bi bi-circle"></i>
                    <span>Enrôler un dossier</span>
                  </Link>
                </li>*/}
                    {/***Menu ADMIN et SUPERADMIN dossiersacteurs_index*/}
                    {(profils.includes("ADMIN") ||
                      profils.includes("SUPERADMIN") ||
                      profils.includes("PC") ||
                      profils.includes("GEC") ||
                      profils.includes("AGEC") ||
                      profils.includes("GCH") ||
                      profils.includes("CCC")) && (
                      <>
                        <li>
                          <Link
                            to={myroutes.dossiers_index}
                            className={`${
                              currentPath == myroutes.dossiers_index && "active"
                            }`}
                          >
                            <i className="bi bi-circle"></i>
                            <span>Liste des dossiers</span>
                          </Link>
                        </li>
                        {!profils.includes("GCH") && (
                          <>
                            <li>
                              <Link
                                to={myroutes.dossierspartiesdocuments_index}
                                className={`${
                                  currentPath ==
                                    myroutes.dossierspartiesdocuments_index &&
                                  "active"
                                }`}
                              >
                                <i className="bi bi-circle"></i>
                                <span>Liste des pièces</span>
                              </Link>
                            </li>

                            <li>
                              <Link
                                to={myroutes.jonctionsdossier_index}
                                className={`${
                                  currentPath ==
                                    myroutes.jonctionsdossier_index && "active"
                                }`}
                              >
                                <i className="bi bi-circle"></i>
                                <span>Liste des jonctions</span>
                              </Link>
                            </li>

                            <li>
                              <Link
                                to={myroutes.tableaudebordstats}
                                className={`${
                                  currentPath == myroutes.tableaudebordstats &&
                                  "active"
                                }`}
                              >
                                <i className="bi bi-circle"></i>
                                <span>Récapitulatif des dossiers</span>
                              </Link>
                            </li>
                          </>
                        )}
                      </>
                    )}
                    {/* 
                
                <li>
                  <Link to={myroutes.dossierspartiesdocuments_create}>
                    <i className="bi bi-circle"></i>
                    <span>Ajouter un document</span>
                  </Link>
                </li>
                
                */}
                  </ul>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link collapsed"
                    data-bs-target="#datesaudiences-nav"
                    data-bs-toggle="collapse"
                    href="#"
                  >
                    <i className="bi bi-layout-text-window-reverse"></i>
                    <span>Audiences</span>
                    <i className="bi bi-chevron-down ms-auto"></i>
                  </a>
                  <ul
                    id="datesaudiences-nav"
                    className="nav-content collapse "
                    data-bs-parent="#sidebar-nav"
                  >
                    {!profils.includes("GCH") && (
                    <li>
                      <Link
                        to={myroutes.datesaudiences_index}
                        className={`${
                          currentPath == myroutes.datesaudiences_index &&
                          "active"
                        }`}
                      >
                        <i className="bi bi-circle"></i>
                        <span>Dossiers aux rôles</span>
                      </Link>
                    </li>
                    )}

                    {/***
                   * (profils.includes("ADMIN") || profils.includes("SUPERADMIN") || profils.includes("GEC")) &&
                    <>
                      <li>
                        <Link to={myroutes.datesaudiences_create} className={`${currentPath == myroutes.datesaudiences_create && "active"}`}>
                          <i className="bi bi-circle"></i>
                          <span>Editer un dossier</span>
                        </Link>
                      </li>
                    </>
                   */}
                    <li>
                      <Link
                        to={myroutes.rolesaudiences_index}
                        className={`${
                          currentPath == myroutes.rolesaudiences_index &&
                          "active"
                        }`}
                      >
                        <i className="bi bi-circle"></i>
                        <span>Rôles d'audiences</span>
                      </Link>
                    </li>
                    {(profils.includes("ADMIN") ||
                      profils.includes("SUPERADMIN") ||
                      profils.includes("GEC") ||
                      profils.includes("AGEC") ||
                      !profils.includes("GCH")) && (
                      <>
                        <li>
                          <Link
                            to={myroutes.calendriersprocedures_index}
                            className={`${
                              currentPath ==
                                myroutes.calendriersprocedures_index && "active"
                            }`}
                          >
                            <i className="bi bi-circle"></i>
                            <span>Calendrier des procédures</span>
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </li>

                {/* End Forms Nav */}
                {!profils.includes("GCH") && (
                <li className="nav-item">
                  <Link
                    to={myroutes.saisines_index}
                    className={`nav-link collapsed ${
                      currentPath == myroutes.saisines_index ? "active" : ""
                    }`}
                  >
                    <i className="fas fa-balance-scale"></i>&nbsp;&nbsp;
                    <span>Saisines</span>
                  </Link>
                </li>
                )}

                {(profil_habilitation.includes("ADMIN-RW") ||
                  profil_habilitation.includes("ADMIN-RO") ||
                  !profils.includes("GCH") ||
                  profils.includes("GEC")) && (
                  <>
                    <li className="nav-heading"></li>
                    <li className="nav-item">
                      <Link
                        to={myroutes.assujetties_index}
                        className={`nav-link collapsed ${
                          currentPath == myroutes.assujetties_index
                            ? "active"
                            : ""
                        }`}
                      >
                        <i className="bi bi-person-standing"></i>&nbsp;&nbsp;
                        <span>Assujetties & Conseils </span>
                      </Link>
                    </li>
                  </>
                )}

                {!profils.includes("CCC") && !profils.includes("PC") && !profils.includes("GCH") && (
                  <>
                    {!profils.includes("GEC") && (
                      <li className="nav-item">
                        <a
                          className="nav-link collapsed"
                          data-bs-target="#presidence-nav"
                          data-bs-toggle="collapse"
                          href="#"
                        >
                          <i className="bi bi-back"></i>
                          <span>Présidence Online</span>
                          <i className="bi bi-chevron-down ms-auto"></i>
                        </a>
                        <ul
                          id="presidence-nav"
                          className="nav-content collapse "
                          data-bs-parent="#sidebar-nav"
                        >
                          {/**Requetes aux fins d'ordonnances */}

                          <>
                            <li>
                              <Link
                                className={`${
                                  currentPath ==
                                    myroutes.dossiers_mes_requetes && "active"
                                }`}
                                to={myroutes.dossiers_mes_requetes}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                  width="24"
                                >
                                  <path d="M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"></path>
                                </svg>
                                &nbsp;
                                <span>Requêtes à fin d'ordonnance</span>
                              </Link>
                            </li>

                            <li className="nav-heading"></li>
                            <li className="nav-item">
                              <Link
                                to={myroutes.communication_index}
                                className={` ${
                                  currentPath == myroutes.communication_index
                                }`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                  width="24"
                                >
                                  <path d="M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"></path>
                                </svg>
                                &nbsp;
                                <span>Communication électronique</span>
                              </Link>
                            </li>

                            {/**<li>
                            <Link to="#"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24">
                                <path d="M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"></path>
                              </svg>&nbsp;
                              <span>Communication électronique</span>
                            </Link>
                          </li>**/}
                          </>
                        </ul>
                      </li>
                    )}

                    <li className="nav-item">
                      <a
                        className="nav-link collapsed"
                        data-bs-target="#greffe-nav"
                        data-bs-toggle="collapse"
                        href="#"
                      >
                        <i className="bi bi-award-fill"></i>
                        <span>Greffe Digital</span>
                        <i className="bi bi-chevron-down ms-auto"></i>
                      </a>
                      <ul
                        id="greffe-nav"
                        className="nav-content collapse "
                        data-bs-parent="#sidebar-nav"
                      >
                        {/**Demande de copie d'arrte et grosse */}
                        {(profils.includes("GEC") ||
                          profils.includes("ADMIN") ||
                          profils.includes("SUPERADMIN")) &&
                          !profils.includes("SJ") && (
                            <li>
                              <Link
                                to={myroutes.demande_arret_index}
                                className={`${
                                  currentPath == myroutes.demande_arret_index
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <i className="bi bi-envelope-paper"></i>
                                &nbsp;&nbsp;
                                <span>Demandes de copie ou grosse </span>
                              </Link>
                            </li>
                          )}

                        {/**Attestation d'instance */}
                        <li>
                          <Link
                            className={`${
                              currentPath ==
                                myroutes.dossiers_mes_attestations && "active"
                            }`}
                            to={myroutes.dossiers_mes_attestations}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="currentColor"
                            >
                              <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"></path>
                            </svg>
                            &nbsp;
                            <span>Attestations d'instance</span>
                          </Link>
                        </li>

                        {/**Attestation d'instance */}
                        <li>
                          <Link
                            className={`${
                              currentPath ==
                                myroutes.dossiers_mes_attestations_radiations &&
                              "active"
                            }`}
                            to={myroutes.dossiers_mes_attestations_radiations}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="currentColor"
                            >
                              <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"></path>
                            </svg>
                            &nbsp;
                            <span>Attestations de radiation de rôle</span>
                          </Link>
                        </li>

                        {/**Attestation de pouvoir */}
                        <li>
                          <Link
                            className={`${
                              currentPath ==
                                myroutes.dossiers_mes_attestations_pourvoi
                                  .replace(":type", "pourvoi")
                                  .replace(":is_pourvoi", "true") && "active"
                            }`}
                            to={myroutes.dossiers_mes_attestations_pourvoi
                              .replace(":type", "pourvoi")
                              .replace(":is_pourvoi", "true")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="currentColor"
                            >
                              <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"></path>
                            </svg>
                            &nbsp;
                            <span>Attestations de pourvoi</span>
                          </Link>
                        </li>

                        {/**Attestation de non pouvoir */}
                        <li>
                          <Link
                            className={`${
                              currentPath ==
                                myroutes.dossiers_mes_attestations_pourvoi
                                  .replace(":type", "pourvoi")
                                  .replace(":is_pourvoi", "false") && "active"
                            }`}
                            to={myroutes.dossiers_mes_attestations_pourvoi
                              .replace(":type", "pourvoi")
                              .replace(":is_pourvoi", "false")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="currentColor"
                            >
                              <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"></path>
                            </svg>
                            &nbsp;
                            <span>Attestations de non pourvoi</span>
                          </Link>
                        </li>

                        {/**Légalisatiosn de pièces */}
                        <li>
                          <Link
                            className={`${
                              currentPath ==
                                myroutes.admin_legalisations && "active"
                            }`}
                            to={myroutes.admin_legalisations}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="currentColor"
                            >
                              <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"></path>
                            </svg>
                            &nbsp;
                            <span>Légalisations de pièces</span>
                          </Link>
                        </li>

                      </ul>
                    </li>
                  </>
                )}

                {(profils.includes("ADMIN") ||
                  profils.includes("SUPERADMIN") ||
                  profils.includes("PDT") ||
                  profils.includes("GEC")) && (
                  <>
                    <li className="nav-heading"></li>
                    <li className="nav-item">
                      <Link
                        to={myroutes.paiements_index}
                        className={`nav-link collapsed ${
                          currentPath == myroutes.paiements_index
                            ? "active"
                            : ""
                        }`}
                      >
                        <i className="bi bi-wallet"></i>&nbsp;&nbsp;
                        <span>Liste des paiements</span>
                      </Link>
                    </li>
                  </>
                )}

                <li className="nav-heading"></li>
                {(profil_habilitation.includes("ADMIN-RW") ||
                  profil_habilitation.includes("ADMIN-RO") ||
                  profils.includes("GEC")) && (
                  <li className="nav-item">
                    <Link
                      to={myroutes.utilisateurs_index}
                      className={`nav-link collapsed ${
                        currentPath == myroutes.utilisateurs_index
                          ? "active"
                          : ""
                      }`}
                    >
                      <i className="bi bi-person"></i>&nbsp;&nbsp;
                      <span>Utilisateurs</span>
                    </Link>
                  </li>
                )}
              </>
            )}

          {/* Menus Statistiques */}
          <li className="nav-heading"></li>

          {/* Même condition que la route (webroute.js), pour qu'un lien visible
              mène toujours quelque part. Le repli sur INTERFACE-ADMIN et
              l'exclusion de GCH sont TRANSITOIRES : une fois VOIR-STATS créée
              et affectée, cette condition se réduit à
              profil_habilitation.includes("VOIR-STATS"). */}
          {(profil_habilitation.includes("VOIR-STATS") ||
            (profil_habilitation.includes("INTERFACE-ADMIN") &&
              !profils.includes("GCH"))) && (
          <li className="nav-item">
            <Link
              to={myroutes.statistiques_globales}
              className={`nav-link collapsed ${
                currentPath == myroutes.statistiques_globales ? "active" : ""
              }`}
            >
              <i className="bi bi-speedometer2"></i>&nbsp;&nbsp;
              <span>Statistiques</span>
            </Link>
          </li>
          )}

          {/* <li className="nav-item">
            <a
              className="nav-link collapsed"
              data-bs-target="#outils-nav"
              data-bs-toggle="collapse"
              href="#"
            >
              <i className="bi bi-speedometer2"></i>
              <span>Statistiques</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </a>
            <ul
              id="outils-nav"
              className="nav-content collapse "
              data-bs-parent="#sidebar-nav"
            >
              <li>
                <Link
                  to={myroutes.statistiques}
                  className={`${
                    currentPath == myroutes.statistiques && "active"
                  }`}
                >
                  <i className="bi bi-circle"></i>
                  <span>Statistiques globales</span>
                </Link>
              </li>
              <li>
                <Link to={myroutes.statistiques_globales} className={`${currentPath == myroutes.statistiques_globales && "active"}`}>
                  <i className="bi bi-circle"></i>
                  <span>Statistiques Globales</span>
                </Link>
              </li> 
            </ul>
          </li>  */}

          {(profils.includes("CMPT") ||
            profils.includes("ADMIN") ||
            profils.includes("SUPERADMIN")) && (
            <>
              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  data-bs-target="#comptable-nav"
                  data-bs-toggle="collapse"
                  href="#"
                >
                  <i className="bi bi-layout-text-window-reverse"></i>
                  <span>Comptabilité</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul
                  id="comptable-nav"
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >
                  <li className="nav-item">
                    <Link
                      to={myroutes.paiements_liste}
                      className={`${
                        currentPath === myroutes.paiements_liste && "active"
                      }`}
                    >
                      <i className="bi bi-circle"></i>
                      <span>Suivi Comptable</span>
                    </Link>
                  </li>

                  <li className="nav-heading"></li>
                  <li className="nav-item">
                    <Link
                      to={myroutes.releve_paiements}
                      className={`${
                        currentPath === myroutes.releve_paiements && "active"
                      }`}
                    >
                      <i className="bi bi-circle"></i>
                      <span>Relevé des recettes</span>
                    </Link>
                  </li>

                  <li className="nav-heading"></li>
                  <li className="nav-item">
                    <Link
                      to={myroutes.etat_paiements}
                      className={`${
                        currentPath === myroutes.etat_paiements && "active"
                      }`}
                    >
                      <i className="bi bi-circle"></i>
                      <span>État récapitulatif</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </>
          )}

          {/* End Tables Nav */}
          {/* Menus Paramètres */}
          {(profil_habilitation.includes("ADMIN-RW") ||
            profil_habilitation.includes("ADMIN-RO")) && (
            <li className="nav-item">
              <a
                className="nav-link collapsed"
                data-bs-target="#parametres-nav"
                data-bs-toggle="collapse"
                href="#"
              >
                <i className="bi bi-gem"></i>
                <span>Paramètres</span>
                <i className="bi bi-chevron-down ms-auto"></i>
              </a>
              <ul
                id="parametres-nav"
                className="nav-content collapse "
                data-bs-parent="#sidebar-nav"
              >
                <li>
                  <Link
                    to={myroutes.voirtout}
                    className={`${
                      currentPath == myroutes.voirtout && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Voir tout</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.calendriers_index}
                    className={`${
                      currentPath == myroutes.calendriers_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Calendrier d'audiences</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.calendriersglobals_index}
                    className={`${
                      currentPath == myroutes.calendriersglobals_index &&
                      "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Calendrier Global</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.categories_index}
                    className={`${
                      currentPath == myroutes.categories_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Categories</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.chambres_index}
                    className={`${
                      currentPath == myroutes.chambres_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Chambres</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.chambresmembres_index}
                    className={`${
                      currentPath == myroutes.chambresmembres_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Chambres membres</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.civilites_index}
                    className={`${
                      currentPath == myroutes.civilites_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Civilites</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.habilitations_index}
                    className={`${
                      currentPath == myroutes.habilitations_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Habilitations</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.historiqueactions_index}
                    className={`${
                      currentPath == myroutes.historiqueactions_index &&
                      "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Historique des actions</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.historiqueconnexions_index}
                    className={`${
                      currentPath == myroutes.historiqueconnexions_index &&
                      "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Historique des connexions</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.natureaffaires_index}
                    className={`${
                      currentPath == myroutes.natureaffaires_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Nature des affaires</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.motifsvalidations_index}
                    className={`${
                      currentPath == myroutes.motifsvalidations_index &&
                      "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Motifs validations</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.objets_index}
                    className={`${
                      currentPath == myroutes.objets_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Objets</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.parties_index}
                    className={`${
                      currentPath == myroutes.parties_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Parties</span>
                  </Link>
                </li>
                {/**
                *  <li>
                  <Link to={myroutes.partiesmembres_index} className={`${currentPath == myroutes.partiesmembres_index && "active"}`}>
                    <i className="bi bi-circle"></i>
                    <span>Parties membres</span>
                  </Link>
                    </li>
                    <li>
                      <Link to={myroutes.partiesprofils_index} className={`${currentPath == myroutes.partiesprofils_index && "active"}`}>
                        <i className="bi bi-circle"></i>
                        <span>Parties profils</span>
                      </Link>
                    </li>
                */}
                <li>
                  <Link
                    to={myroutes.poles_index}
                    className={`${
                      currentPath == myroutes.poles_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Pôles</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.profils_index}
                    className={`${
                      currentPath == myroutes.profils_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Profils</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to={myroutes.procedures_index}
                    className={`${
                      currentPath == myroutes.procedures_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Procédures</span>
                  </Link>
                </li>
                {/**
                 * <li>
                  <Link to={myroutes.rolesmembres_index} className={`${currentPath == myroutes.rolesmembres_index && "active"}`}>
                    <i className="bi bi-circle"></i>
                    <span>Rôles membres</span>
                  </Link>
                  </li>
                 */}
                <li>
                  <Link
                    to={myroutes.statuts_index}
                    className={`${
                      currentPath == myroutes.statuts_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Statuts</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={myroutes.statutsdossiers_index}
                    className={`${
                      currentPath == myroutes.statutsdossiers_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Statuts dossiers</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={myroutes.statutsjuridiques_index}
                    className={`${
                      currentPath == myroutes.statutsjuridiques_index &&
                      "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Statuts juridiques</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={myroutes.tribunaux_index}
                    className={`${
                      currentPath == myroutes.tribunaux_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Tribunaux</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={myroutes.typesacteurs_index}
                    className={`${
                      currentPath == myroutes.typesacteurs_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Types d'acteurs</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={myroutes.typesdocuments_index}
                    className={`${
                      currentPath == myroutes.typesdocuments_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Types documents</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={myroutes.typesparties_index}
                    className={`${
                      currentPath == myroutes.typesparties_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Types parties</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to={myroutes.typesprocedures_index}
                    className={`${
                      currentPath == myroutes.typesprocedures_index && "active"
                    }`}
                  >
                    <i className="bi bi-circle"></i>
                    <span>Types procédures</span>
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {/* End Menus paramètres*/}

          {(profils.includes("PDT") || profils.includes("SJ")) && (
            <>
              {profils.includes("PDT") && (
                <>
                  <li className="nav-heading"></li>
                  <li className="nav-item">
                    <Link
                      to={myroutes.dossiers_index}
                      className={`nav-link collapsed ${
                        currentPath == myroutes.dossiers_index ? "active" : ""
                      }`}
                    >
                      <i className="bi bi-journal-text"></i>
                      <span>Liste des dossiers</span>
                    </Link>
                  </li>
                  <li className="nav-heading"></li>
                  <li className="nav-item">
                    <Link
                      to={myroutes.paiements_index}
                      className={`nav-link collapsed ${
                        currentPath == myroutes.paiements_index ? "active" : ""
                      }`}
                    >
                      <i className="bi bi-wallet"></i>&nbsp;&nbsp;
                      <span>Liste des paiements</span>
                    </Link>
                  </li>
                </>
              )}

              <li className="nav-item">
                <a
                  className="nav-link collapsed"
                  data-bs-target="#services-nav"
                  data-bs-toggle="collapse"
                  href="#"
                >
                  <i className="bi bi-award-fill"></i>
                  <span>Présidence Online</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul
                  id="services-nav"
                  className="nav-content collapse"
                  data-bs-parent="#sidebar-nav"
                >
                  {/* Demandes de copie ou grosse - uniquement si ce n'est pas le profil SJ */}
                  {/**{!profils.includes("SJ") &&
                  <li>
                    <Link
                      to={myroutes.demande_arret_index}
                      className={`${currentPath === myroutes.demande_arret_index ? "active" : ""}`}
                    >
                      <i className="bi bi-envelope-paper"></i>&nbsp;&nbsp;
                      <span>Demandes de copie ou grosse</span>
                    </Link>
                  </li>
                }**/}

                  {/* Requêtes à fin d'ordonnance */}
                  <li>
                    <Link
                      to={myroutes.dossiers_mes_requetes}
                      className={`${
                        currentPath === myroutes.dossiers_mes_requetes
                          ? "active"
                          : ""
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="24"
                      >
                        <path d="M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"></path>
                      </svg>
                      &nbsp;
                      <span>Requêtes à fin d'ordonnance</span>
                    </Link>
                  </li>

                  {/* Attestations d'instance */}

                  <li className="nav-heading"></li>
                  <li className="nav-item">
                    <Link
                      to={myroutes.communication_index}
                      className={` ${
                        currentPath == myroutes.communication_index
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="24"
                      >
                        <path d="M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"></path>
                      </svg>
                      &nbsp;
                      <span>Communication électronique</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </>
          )}
        </ul>
      </aside>
      {/* End Sidebar*/}
    </React.Fragment>
  );
}
